import { tipoEntidade } from './../../../../core/models/dominio';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { CargoReferenciaService } from '@core/services/cargoreferencia.service';
import { DominiosService } from '@core/services/dominios.service';
import { FormService } from '@core/services/form.service';
import { MessageService } from '@core/services/message.service';
import { TipoEntidadeService } from '@core/services/tipoentidade.service';
import { TipoGrupoService } from '@core/services/TipoGrupoService';
import { trimObjectStrings } from '@shared/util/util';
import { NzModalService } from 'ng-zorro-antd/modal';
import { forkJoin } from 'rxjs';
import { pairwise, startWith } from 'rxjs/operators';


@Component({
  selector: 'app-dominio-form',
  templateUrl: './dominio-form.component.html',
  styleUrls: ['./dominio-form.component.scss']
})
export class DominioFormComponent implements OnInit {

  @ViewChild('formElement') formElement!: ElementRef;

  @Input() isModal: boolean = false;
  @Input() item: any;
  @Input() nomeDominio!: string;
  @Input() idParams!: number;

  dominioForm!: FormGroup;
  acao!: RouteAction;
  acaoEnum = RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  actionActual!: RouteAction;
  titulo!: string;
  cargoSubordinadoList: any[] = [];
  tipoGruposList: any[] = [];
  tipoEntidadeList: any[] = [];
  nzFilterOption = (): boolean => true;
  cargoReferenciaList: any[] = [];
  especializacaoSubtipoList: any[] = [];
  telasPermitidasList: any[] = [];
  lockedIds = new Set<number>();
  lockedLabels: string[] = [];
  lockedMessage: string | null = null;


  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private service: DominiosService,
    private tipoEntidadeService: TipoEntidadeService,
    private cargoReferenciaService: CargoReferenciaService,
    private formService: FormService,
    private messageService: MessageService,
    private tipoGrupoService: TipoGrupoService,
    private modalService: NzModalService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.construirForm();
    this.carregarSelects();
    this.carregarListas();

    if (!this.isModal) {
      this.checkUrl();
    }

    if (this.idParams && this.isModal) {
      this.editar = true;
    }

    if (this.editar || this.visualizar) {
      if (!this.isModal) {
        this.buscarDados();
      }
    }

    if (this.nomeDominio != 'CARGO_REFERENCIA') {
      this.dominioForm.get('isEfetivo')?.valueChanges.subscribe((isEfetivo: boolean) => {
        // Se o valor de isEfetivo for alterado
        if (isEfetivo !== null) {
          if (isEfetivo) {
            // Se 'isEfetivo' for true, então 'isSuplente' deve ser false
            this.dominioForm.patchValue({
              isSuplente: false
            }, { emitEvent: false });
          } else {
            // Se 'isEfetivo' for false, então 'isSuplente' deve ser true
            this.dominioForm.patchValue({
              isSuplente: true
            }, { emitEvent: false });
          }
        }
      });
    }

    this.obrigatorieadeSubtipoEntidade();
    this.carregaComboEspecializacao();

    const especCtrl = this.dominioForm.get('especificacoes');
    especCtrl?.valueChanges
      .pipe(startWith([]), pairwise())
      .subscribe(([prev, curr]: [any[], any[]]) => {
        if (!prev || !curr) return;
        const removed = prev.filter(p => !curr.some(c => c?.id === p?.id));
        const removedLocked = removed.filter(r => this.lockedIds.has(r?.id));
        if (removedLocked.length) {
          this.messageService.warning(
            `${removedLocked.map(x => x.nome).join(', ')} possui(m) cargos vinculados e não pode(m) ser removido(s).`
          );
          especCtrl.setValue([...curr, ...removedLocked], { emitEvent: false });
        }
      });

  }

  construirForm() {
    this.dominioForm = this.fb.group({
      // nome: ['', Validators.required],
      nome: [],
      telasPermitidas: [],
      cargoSubordinadoId: [],
      tipoEntidade: [],
      // efetivo: [null],
      // suplente: [null],
      // isEfetivo: [true],
      isSuplente: [false],
      tipoGrupo: [],
      cargoReferencia: [''],
      nivelHierarquico: [''],
      cargoReferenciaId: [''],
      cargoSubordinado: [''],
      tipoEntidadeId: [''],
      sigiloso: [false],
      especificacoes: [undefined]
    });

    if (this.nomeDominio === 'CARGO_TIPO_ENTIDADE') {
      this.dominioForm.get('cargoReferencia')?.setValidators([Validators.required]);
      this.dominioForm.get('tipoEntidade')?.setValidators([Validators.required]);
      this.dominioForm.get('nivelHierarquico')?.setValidators([Validators.required]);
      this.dominioForm.get('cargoSubordinado')?.clearValidators();
    } else {
      this.dominioForm.get('cargoReferencia')?.clearValidators();
      this.dominioForm.get('tipoEntidade')?.clearValidators();
      this.dominioForm.get('nivelHierarquico')?.clearValidators();
      this.dominioForm.get('cargoSubordinado')?.clearValidators();
    }

    // Atualiza a validação para todos os campos
    this.dominioForm.updateValueAndValidity();

  }

  obrigatorieadeSubtipoEntidade() {
    const nomeSubTipoEntidade = this.dominioForm.get('nome');
    const tipoEntidadeCtrl = this.dominioForm.get('tipoEntidade');
    if (this.nomeDominio == 'SUB_TIPO_ENTIDADE') {
      nomeSubTipoEntidade?.setValidators([Validators.required]);
      tipoEntidadeCtrl?.setValidators([Validators.required]);
    } else {
      nomeSubTipoEntidade?.clearValidators();
      tipoEntidadeCtrl?.clearValidators();
    }
  }

  carregaComboEspecializacao() {
    if (this.nomeDominio == 'SUB_TIPO_ENTIDADE') {
      const orgao = 9;
      this.tipoEntidadeControl?.valueChanges.subscribe((tipoEntidade) => {
        if (tipoEntidade == orgao) {
          // quando vier por troca manual, mantém a mesclagem com this.lockedIds
          this.tipoEntidadeService.listarEspecificacoes().subscribe((todos: any[]) => {
            this.especializacaoSubtipoList = (todos || []).map(opt => ({
              ...opt,
              temCargosVinculados: this.lockedIds.has(opt.id)
            }));
          });
        } else {
          this.especializacaoSubtipoList = [];
        }
      });
    }
  }


  onCargoReferenciaChange(cargoReferencia: any) {
    console.log('Alteração de Cargo Referência:', cargoReferencia);

    if (cargoReferencia) {
      // Se 'cargoReferencia' é o objeto completo, usamos seu id. Se for o id, usamos diretamente.
      const cargoReferenciaId = cargoReferencia.id || cargoReferencia;
      console.log('ID do Cargo Referência:', cargoReferenciaId);

      // Lógica para obter os cargos subordinados com base no cargo referência
      this.cargoSubordinadoList = this.getCargoSubordinadoPorCargoReferencia(cargoReferenciaId);
      console.log('Lista de Cargos Subordinados:', this.cargoSubordinadoList);

      // Preencher automaticamente o campo cargo subordinado com o primeiro item da lista
      if (this.cargoSubordinadoList.length > 0) {
        console.log('Preenchendo campo Cargo Subordinado com o primeiro item:', this.cargoSubordinadoList[0].id);
        this.dominioForm.patchValue({ cargoSubordinado: this.cargoSubordinadoList[0].id });
      } else {
        // Se não houver subordinados disponíveis, limpar o campo de subordinado
        console.log('Nenhum Cargo Subordinado encontrado, limpando o campo.');
        this.dominioForm.patchValue({ cargoSubordinado: null });
      }
    } else {
      console.log('Nenhum Cargo Referência selecionado.');
    }
  }

  // Função para obter cargos subordinados com base no cargo referência
  getCargoSubordinadoPorCargoReferencia(cargoReferenciaId: number) {
    console.log('Buscando cargos subordinados para o Cargo Referência com ID:', cargoReferenciaId);

    // Filtra e retorna apenas os subordinados, sem incluir o cargo referência
    const subordinados = this.cargoReferenciaList
      .filter(cargo => cargo.id === cargoReferenciaId && cargo.cargoSubordinado)
      .flatMap(cargo => cargo.cargoSubordinado ? [{
        id: cargo.cargoSubordinado.id,  // ID do subordinado
        nomeCargoReferencia: cargo.cargoSubordinado.nomeCargoReferencia,  // Nome do subordinado
      }] : []);

    console.log('Cargos Subordinados encontrados:', subordinados);
    return subordinados;
  }





  carregarSelects() {
    this.service.telasPermitidas().subscribe((res) => this.telasPermitidasList = res);
  }

  carregarListas(): void {
    forkJoin({
      tiposEntidade: this.tipoEntidadeService.listarPorTipoEnum(),
      cargosReferencia: this.cargoReferenciaService.listar(),
      tiposGrupo: this.tipoGrupoService.listar()
    }).subscribe(
      ({
        tiposEntidade,
        tiposGrupo,
        cargosReferencia
      }) => {
        this.cargoReferenciaList = cargosReferencia;
        this.tipoEntidadeList = tiposEntidade;
        this.tipoGruposList = tiposGrupo;
      }
    );
  }


  buscarDados() {
    console.log('Buscando dados para edição/visualização com ID:', this.idParams, 'e nomeDominio:', this.nomeDominio);

    if (this.nomeDominio === 'SUB_TIPO_ENTIDADE') {
      this.tipoEntidadeService.buscarSubTipoEntidadePorId(this.idParams).subscribe((res: any) => {
        // Normaliza resposta
        res.nome = res.nomeSubTipoEntidade;
        res.tipoEntidade = res.idTipoEntidade || [];
        res.especificacoes = res.especificacoes || [];

        // 🔹 bloqueados
        const bloqueados = res.especificacoes.filter((e: any) => e.temCargosVinculados);
        this.lockedIds = new Set<number>(bloqueados.map((e: any) => e.id));
        this.lockedLabels = bloqueados.map((e: any) => e.nome);

        // 🔹 mensagem
        if (bloqueados.length) {
          const nomes = bloqueados.map((b: any) => b.nome).join(', ');
          this.lockedMessage =
            bloqueados.length === 1
              ? `O tipo de órgão ${nomes} possui cargos vinculados e não pode ser removido.`
              : `Os tipos de órgão ${nomes} possuem cargos vinculados e não podem ser removidos.`;
        } else {
          this.lockedMessage = null;
        }

        // 🔹 preenche o form
        this.dominioForm.patchValue({ ...res });

        if (this.editar || this.visualizar) {
          this.dominioForm.get('tipoEntidade')?.disable({ emitEvent: false });
        }

        // 🔹 se for tipo "Órgão" (idTipoEntidade === 9), carrega todas as opções
        if (res.idTipoEntidade === 9) {
          this.tipoEntidadeService.listarEspecificacoes().subscribe((todos: any[]) => {
            this.especializacaoSubtipoList = (todos || []).map(opt => ({
              ...opt,
              temCargosVinculados: this.lockedIds.has(opt.id)
            }));
          });
        }
      });
    } else {
      this.service.consultarDominioPorId(this.nomeDominio, this.idParams).subscribe((res: any) => {
        // 🔹 lógica de efetivo/suplente
        let efetivo = res?.isEfetivo ?? true;
        let suplente = res?.isSuplente ?? false;

        if (suplente) {
          efetivo = false;
        }

        this.dominioForm.patchValue({
          ...res,
          isEfetivo: efetivo,
          isSuplente: suplente
        });
      });
    }
  }




  submit() {
    this.formService.validateAllFormFields(this.dominioForm);
    const messages = this.formService.getValidationsMessages(this.dominioForm, this.formElement);
    if (messages.length) {
      this.messageService.warning('Existem campos obrigatórios a serem preenchidos.');
      return;
    }


    let objSubmit = { ...this.dominioForm.getRawValue() };
    if (objSubmit?.tipoGrupo)
      objSubmit.tipoGrupo = typeof objSubmit.tipoGrupo === 'object' ? objSubmit.tipoGrupo.id : objSubmit.tipoGrupo;

    objSubmit.cargoReferenciaId = this.dominioForm.get('cargoReferencia')?.value?.id ?? this.dominioForm.get('cargoReferencia')?.value;
    objSubmit.cargoSubordinadoId = this.dominioForm.get('cargoSubordinado')?.value?.id ?? this.dominioForm.get('cargoSubordinado')?.value;
    objSubmit.tipoEntidadeId = this.dominioForm.get('tipoEntidade')?.value?.id ?? this.dominioForm.get('tipoEntidade')?.value;

    objSubmit = trimObjectStrings(objSubmit);

    let objEnvioSubTipo: any = {};
    if (this.nomeDominio === 'SUB_TIPO_ENTIDADE') {
      objEnvioSubTipo.nome = this.dominioForm.get('nome')?.value;
      objEnvioSubTipo.idTipoEntidade = this.dominioForm.get('tipoEntidade')?.value;
      objEnvioSubTipo.especificacaoIds = this.dominioForm.get('especificacoes')?.value?.map((item: any) => item.id) ?? [];
    }

    if (this.nomeDominio != 'SUB_TIPO_ENTIDADE') {
      if (this.acao === RouteAction.Inserir) {
        this.service.cadastrar(this.nomeDominio, objSubmit).subscribe((res: any) => {
          this.messageService.success('Domínio inserido com sucesso.');
          if (this.nomeDominio === 'GRUPO_ECONOMICO' && res?.id) {
            this.router.navigate([`/dominios/${this.nomeDominio}/editar/${res.id}`], { state: { titulo: this.titulo } });
          } else {
            this.voltar();
          }
        });
        return;
      }

      if (this.acao === RouteAction.Editar) {
        this.service.editar(this.nomeDominio, this.idParams, objSubmit).subscribe(() => {
          this.messageService.success('Domínio atualizado com sucesso.');
        });
      }
    }

    if (this.nomeDominio === 'SUB_TIPO_ENTIDADE') {
      if (this.acao === RouteAction.Inserir) {
        this.tipoEntidadeService.salvarSubtipoEntidade(objEnvioSubTipo).subscribe((res: any) => {
          this.messageService.success('Domínio inserido com sucesso.');
          if (this.nomeDominio === 'SUB_TIPO_ENTIDADE' && res?.id) {
            this.router.navigate([`/dominios/${this.nomeDominio}/editar/${res.id}`], { state: { titulo: this.titulo } });
          } else {
            this.voltar();
          }
        });
        return;
      }

      if (this.acao === RouteAction.Editar) {
        objEnvioSubTipo.id = Number(this.idParams);
        this.tipoEntidadeService.editarSubtipoEntidade(objEnvioSubTipo).subscribe(() => {
          this.messageService.success('Domínio atualizado com sucesso.');
        });
      }
    }
  }

  voltar() {
    if (this.isModal) {
      this.modalService.closeAll();
    } else {
      window.history.back();
    }
  }



  checkUrl() {
    this.route.data.subscribe((data) => {
      this.acao = data['acao'];
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;
      this.visualizar = this.acao == RouteAction.Visualizar;
    });

    this.idParams = this.route.snapshot.params['id'];
    this.nomeDominio = this.route.snapshot.params['nomeDominio'];

    const nomeEditado = history.state.titulo;
    const nomeDominioFormatado = nomeEditado === 'Grupo' ? 'Grupo de Correspondência' : nomeEditado;
    this.titulo = this.inserir ? `Cadastrar Domínio - ${nomeDominioFormatado}` : `Editar Domínio - ${nomeDominioFormatado}`;
  }

  compareFn(a: any, b: any): boolean {

    // Caso b seja apenas um número e a seja um objeto com um campo 'id'
    if (typeof b === 'number' && a?.id !== undefined) {
      return a.id === b;
    }

    // Caso a seja um objeto com um campo 'id' e b também seja um objeto com um campo 'id'
    if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    }

    // Outras comparações conforme a lógica original
    if (typeof a === 'number') {
      b = isNaN(Number(b)) ? b : Number(b);
      return a === b;
    }

    if (typeof a === 'string') {
      b = b != null ? b.toString() : b;
      return a.toLowerCase() === b.toLowerCase();
    }

    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = (typeof b === 'string') ? b === 'true' : b;
      return a === b;
    }

    if (Array.isArray(a) && Array.isArray(b) && a.length === b.length) {
      const sortedA = a.slice().sort((x: any, y: any) => (x.idEntidade || 0) - (y.idEntidade || 0));
      const sortedB = b.slice().sort((x: any, y: any) => (x.idEntidade || 0) - (y.idEntidade || 0));
      return sortedA.every((itemA, index) => this.compareFn(itemA, sortedB[index]));
    }

    if (a?.idEntidade !== undefined && b?.idEntidade !== undefined) {
      return a.idEntidade === b.idEntidade;
    }

    if (Array.isArray(a) && a.length && typeof b === 'number') {
      return a[0]?.idEntidade === b;
    }

    if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    }

    if (a !== undefined && b !== undefined) {
      return a === b;
    }

    return a === b;
  }

  compareGrupoFn(a: any, b: any): boolean {
    if (a?.id) {
      return a?.id === b;
    }
    else {
      return a === b;
    }
  }

  compareEspecificacaoFn(a: any, b: any): boolean {
    if (!a || !b) return a === b;
    if (a.id !== undefined && b.id !== undefined) {
      return a.id === b.id;
    }
    if (a.nome !== undefined && b.nome !== undefined) {
      return a.nome === b.nome;
    }
    return a === b;
  }

  get tipoEntidadeOrgao() {
    const orgao = 9;
    return this.dominioForm.get('tipoEntidade')?.value === orgao;
  }

  get tipoEntidadeControl() {
    return this.dominioForm.get('tipoEntidade');
  }
}
